module.exports = __webpack_public_path__ + "img/darkgrownflowbutton.60ed95cd.png";